import PropTypes from 'prop-types';
import Modal from '../Modal';
import {
  ConfirmationContent,
  ConfirmationMessage,
  ButtonGroup,
  ConfirmButton,
  CancelButton,
} from './ConfirmationModal.style';

const ConfirmationModal = ({
  isModalHidden,
  onCloseModal,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonColor = '#0070CD',
  isLoading = false,
}) => (
  <Modal
    isModalHidden={isModalHidden}
    onCloseModal={onCloseModal}
    title={title}
    extendModalContent="max-width: 400px;"
  >
    <ConfirmationContent>
      <ConfirmationMessage>{message}</ConfirmationMessage>
      <ButtonGroup>
        <CancelButton onClick={onCloseModal} disabled={isLoading}>
          {cancelText}
        </CancelButton>
        <ConfirmButton
          onClick={onConfirm}
          disabled={isLoading}
          confirmButtonColor={confirmButtonColor}
        >
          {isLoading ? 'Loading...' : confirmText}
        </ConfirmButton>
      </ButtonGroup>
    </ConfirmationContent>
  </Modal>
);

ConfirmationModal.propTypes = {
  isModalHidden: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmButtonColor: PropTypes.string,
  isLoading: PropTypes.bool,
};

ConfirmationModal.defaultProps = {
  confirmText: 'Confirm',
  cancelText: 'Cancel',
  confirmButtonColor: '#0070CD',
  isLoading: false,
};

export default ConfirmationModal;
